import { useEffect, useRef } from 'react';

export type ExerciseIFrameProps = {
  exerciseUrl: string;
  medialink: {
    name: string;
    kind: string;
  };
  onExerciseFinished: () => void;
};

const ExerciseIframe = ({ exerciseUrl, medialink, onExerciseFinished }: ExerciseIFrameProps): JSX.Element => {
  const playerFinished = useRef(false);
  const { hostname } = new URL(exerciseUrl);

  useEffect(() => {
    const onMessage = (event: MessageEvent): void => {
      if (!hostname) return;
      if (!event.origin.includes(hostname)) return;

      switch (medialink.kind) {
        case 'exercise-eduhint':
          if (!(event.data && event.data.toLowerCase().indexOf('playerfinished') >= 0)) return;
          break;
        case 'exercise-edumatic':
        case 'exercise-assessmentq':
          // playerfinished for reviewing, sessionfinished for exercising
          if (
            !(
              event.data.toLowerCase().indexOf('playerfinished') >= 0 ||
              event.data.toLowerCase().indexOf('sessionfinished') >= 0
            )
          ) {
            return;
          }

          break;
        default:
          return;
      }

      if (!playerFinished.current) onExerciseFinished();
      playerFinished.current = true;
    };

    window.addEventListener('message', onMessage);

    return (): void => {
      window.removeEventListener('message', onMessage);
    };
  }, [onExerciseFinished, hostname, medialink]);

  return <iframe className="exercise-iframe" src={exerciseUrl} title={medialink.name} />;
};

export { ExerciseIframe };
